module.exports = __webpack_public_path__ + "static/img/年度最佳扫地机器人.e6d48ad5.png";